export default __webpack_public_path__ + "static/media/freshFruits.c06ef822.png";